<div class="relative flex flex-row justify-end">
    <div class="shadow-md rounded-lg bg-white px-8 py-4 flex flex-row gap-4">
      <div
        class="flex flex-row gap-2 items-center hover:cursor-pointer"
        (click)="toggleFilterBtn()"
      >
        <img
          src="../../../../../assets/icons/filters.svg"
          [width]="16"
          [height]="16"
          alt="filter-icon"
        />
        <p>Filter</p>
      </div>
      <ng-container>
        <div class="flex flex-row gap-2 bg-orange-500/35 rounded-lg px-2 py-0">
            <p class='italic'>{{dateFilter.name}}</p>
            <button (click)="handleClear()" aria-label="Clear date filter">
              <img src="../../../../../assets/icons/x-close.svg"
                [width]="14"
                [height]="14"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>
      </ng-container>
    </div>
    <div
      class="absolute top-20 right-0 bg-white rounded-lg shadow-md z-100"
      [class.hidden]="!filterIsOpen"
    >
      <div class="flex flex-row justify-between px-6 py-3">
        <p class="text-sm">Filter</p>
        <button (click)="toggleFilterBtn()" aria-label="Close filter panel">
          <img
            src="../../../../../assets/icons/x-close.svg"
            [width]="24"
            [height]="24"
            alt=""
            aria-hidden="true"
          />
        </button>
      </div>
      <div class="text-right flex flex-col gap-2 px-6">
        <div class="min-w-[307px]" [ngClass]="{ 'rounded-b-none': filterValueIsOpen }">
          <div>
            <button
              (click)="toggleDropdown()"
              class="text-neutral-600 bg-neutral-50 rounded-md flex flex-row justify-between gap-3 items-center capitalize w-full px-3 py-2"
              [ngClass]="{ 'rounded-b-none': filterValueIsOpen }"
            >
              <p class="text-sm">{{ selected.name }}</p>
              <img
                src="/assets/icons/chevronDown.svg"
                width="10"
                height="10"
                alt="chevron-down"
                [ngClass]="{ 'rotate-180': filterValueIsOpen, 'rotate-0': !filterValueIsOpen }"
              />
            </button>
          </div>

          @if (filterValueIsOpen) {
            <div
              @dropdownAnimation
              class="w-full rounded-t-none rounded-md focus:outline-none bg-neutral-50"
            >
              @for (option of options; track option.value) {
                <div class="px-1 py-1" [attr.key]="option.value">
                  <button
                    class="group flex w-full items-center rounded-md px-2 py-2 !text-sm"
                    [ngClass]="{
                      'bg-orange-550 text-amber-600': selected.value === option.value,
                      'text-neutral-900': selected.value !== option.value
                    }"
                    (click)="handleSetFilter(option)"
                  >
                    {{ option.name }}
                  </button>
                </div>
              }
            </div>
          }
        </div>
        @if (selected.value == 'custom') {
          <div class="bg-neutral-50 text-start text-neutral-600 px-3 py-2 text-sm rounded-lg flex flex-row items-center gap-3">
            <div class="flex items-center gap-2">
              <label for="date-filter-start" class="text-xs text-neutral-500">From</label>
              <input #startDateInput id="date-filter-start" type="date" class="sz-input !w-[130px] !py-1 text-xs"
                     [value]="formatDateForInput(selectedDates[0])"
                     (change)="handleStartDateChange($event)" />
            </div>
            <span class="text-neutral-400">-</span>
            <div class="flex items-center gap-2">
              <label for="date-filter-end" class="text-xs text-neutral-500">To</label>
              <input #endDateInput id="date-filter-end" type="date" class="sz-input !w-[130px] !py-1 text-xs"
                     [value]="formatDateForInput(selectedDates[1])"
                     (change)="handleEndDateChange($event)" />
            </div>
          </div>
        }
      </div>

      <div class="flex flex-row justify-center items-center gap-3 px-6 py-8">
        <button class="sz-btn-outline w-[120px]" (click)="handleClear()">Clear</button>
        <button class="sz-btn-primary w-[120px]" (click)="applyFilter()">Apply</button>
      </div>
    </div>
  </div>